import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getBroadcastComments } from 'api/comment.service';
import { useToast } from 'hooks/ui';
import type { TComment } from 'models/task-comment.model';
import { commentKeys } from './queryKeys';

export const useBroadcastCommentsGetQuery = (broadcastId: string) => {
  const toast = useToast();

  const query = useQuery({
    queryKey: commentKeys.broadcast(broadcastId),
    queryFn: (): Promise<TComment[]> => getBroadcastComments(broadcastId),
    enabled: !!broadcastId,
    refetchOnWindowFocus: false,
  });

  const { error } = query;

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error, toast]);

  return query;
};
